import React, { Component } from 'react'
import Mask from './mask'
import style from './style.css'


export default class Text extends Component {

    render() {
        let { handleChange, iconRight, iconLeft, error, ...other } = this.props
        return (

            <div className={style.boxField}>
                <label>
                    <input
                        {...other}
                        ref='input'
                        className={`${style.text} ${(this.props.transparent) ? style.transparent : ''} ${this.props.className || ''}`}
                        type='text'
                        placeholder={this.props.placeholder || ' '}
                        onKeyUp={this.props.mask ? (e) => Mask(e, this.props.mask, (e) => {
                            if(this.props.handleChange)
                                this.props.handleChange(e)
                        }) : null}
                        onChange={this.props.handleChange || null}
                        disabled={this.props.disabled}
                        />
                        {
                            (error)
                            ? <span className={style['error-icon']}>&#9888;</span>
                            : ''
                        }
                        {
                            (error)
                            ? <span className={style.error}>{error}</span>
                            : ''
                        }
                        {
                            (iconLeft)
                            ? <span className={style.iconLeft}>{iconLeft}</span>
                            : ''
                        }
                        {
                            (iconRight)
                            ? <span className={style.iconRight}>{iconRight}</span>
                            : ''
                        }

                        {this.props.label && (
                            <span className={style.placeholderFloat}>
                                <span className={style.placeholderFloatText}>{this.props.label}</span>
                                <hr className={style.lineWhite} />
                            </span>
                        )}
                </label>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/SPRINTA/atoms/Forms/text.js